// extracted by mini-css-extract-plugin
export var cartContainer = "_ol-4";
export var gray = "_ol-1";
export var itemContainer = "_ol-2";
export var itemDetails = "_ol-3";
export var strong = "_ol-0";